module.exports = __webpack_public_path__ + "static/Muli-Regular.a401afc3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-Regular.ttf
// module id = 339
// module chunks = 114276838955818